import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mercedesbenztaxiserviceinhyderabad() {



  const cardData =
  {
    keyword: 'Mercedes Benz Taxi Services in Hyderabad',
    heading: 'Aaryan Travels: Mercedes Benz Taxi Services in Hyderabad',
    headingDescription: 'Aaryan Travels offers premium Mercedes Benz Taxi Services in Hyderabad for corporate executives, VIP guests, wedding events, and luxury travelers who prefer elegance and comfort. Whether you need a chauffeur-driven Mercedes for airport pickups from Rajiv Gandhi International Airport, business meetings in HITEC City, or high-profile travel across Banjara Hills and Jubilee Hills, our fleet ensures a sophisticated and seamless ride. With professional chauffeurs, plush leather interiors, and on-request amenities like bottled water and Wi-Fi, Aaryan Travels delivers a world-class travel experience. For those seeking a blend of luxury and reliability, our Mercedes Benz taxi services in Hyderabad are the ideal choice.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Built in 1591 by Sultan Muhammad Quli Qutb Shah, Charminar is Hyderabad’s most iconic monument. Its four grand minarets and Indo-Islamic architecture attract tourists from across the world. Surrounded by bustling markets like Laad Bazaar, it is a paradise for shopping bangles and pearls. Lit up beautifully at night, Charminar is Hyderabad’s timeless symbol of heritage and culture."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress once known for its diamond trade, including the famous Kohinoor. Its acoustic architecture, royal palaces, and secret tunnels fascinate history lovers. The evening light and sound show narrates tales of the Qutb Shahi dynasty. Trekking to the top offers panoramic city views. Golconda Fort is Hyderabad’s glorious representation of power and legacy."
  },
  {
    "title": "Ramoji Film City",
    "description": "Spread over 2,000 acres, Ramoji Film City is the world’s largest film studio complex. It features film sets, amusement parks, live shows, and adventure zones. Visitors can explore fantasy-themed attractions like Bahubali sets and royal palaces. It’s a full-day entertainment destination. Ramoji Film City is Hyderabad’s magical world of cinema and fun."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar is a heart-shaped lake built in 1563, connecting Hyderabad and Secunderabad. In its center stands a giant monolithic Buddha statue, accessible via ferry rides. Evening cruises with lighting and music offer a relaxing experience. Hussain Sagar is Hyderabad’s scenic spot for peace and leisure."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a stunning white marble temple located atop a hill overlooking the city. Dedicated to Lord Venkateswara, it offers panoramic views of Hussain Sagar Lake and Hyderabad skyline. The peaceful atmosphere attracts devotees and tourists alike. Birla Mandir is Hyderabad’s serene hilltop sanctuary."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, housing over 40,000 artifacts collected by Nawab Mir Yousuf Ali Khan. Exhibits include sculptures, weapons, clocks, and famous Veiled Rebecca statue. The museum offers a trip through global history and culture. Salar Jung Museum is Hyderabad’s grand treasury of art and antiquity."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the official residence of the Nizams of Hyderabad. Its grand courtyards, chandeliers, and vintage car collection reflect royal opulence. Events and exhibitions are often hosted here. The architecture blends Persian, Indo-Saracenic, and European styles. Chowmahalla Palace is Hyderabad’s royal masterpiece."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of India’s largest zoos, home to tigers, lions, elephants, and exotic birds. Safari rides and toy trains add adventure for families. The lush green surroundings make it ideal for picnics. Nehru Zoo is Hyderabad’s wildlife retreat for nature lovers."
  },
  {
    "title": "Laad Bazaar",
    "description": "Located near Charminar, Laad Bazaar is famous for its colorful lacquer bangles, pearls, and wedding accessories. Narrow lanes filled with sparkling shops create a vibrant atmosphere. Bargaining adds to the fun. Laad Bazaar is Hyderabad’s traditional shopping haven."
  },
  {
    "title": "Jalavihar Water Park",
    "description": "Jalavihar is Hyderabad’s popular water park located on Necklace Road. It features thrilling slides, wave pools, and family play areas. The park is ideal for summer fun and group outings. Nearby eateries and lakeside views enhance the experience. Jalavihar is Hyderabad’s splash-filled entertainment zone."
  }
],



"services": [
  {
    "name": "Mercedes Benz Taxi Services in Hyderabad",
    "description": "Mercedes Benz Taxi Services in Hyderabad provide a luxurious and dependable travel experience designed for corporate executives, VIP guests, and travelers who value comfort and sophistication. Each ride is powered by an elegant Mercedes vehicle paired with a professional chauffeur, ensuring smooth navigation, punctual arrivals, and a premium atmosphere. Whether for airport transfers, city tours, or business commutes, this service offers a blend of class, convenience, and reliability unmatched in corporate travel."
  },
  {
    "name": "Luxury Mercedes Cab Hyderabad",
    "description": "Luxury Mercedes Cab Hyderabad delivers high-end transportation services using a modern fleet of Mercedes-Benz vehicles. Ideal for business meetings, special events, and executive transfers, this service ensures every journey is elegant, comfortable, and efficient. Professional chauffeurs and well-maintained cars combine to create a truly first-class travel experience that reflects professionalism and prestige."
  },
  {
    "name": "Chauffeur Mercedes Hyderabad",
    "description": "Chauffeur Mercedes Hyderabad provides expertly driven Mercedes cars with chauffeurs trained in corporate etiquette and customer care. This service caters to executives, VIPs, and travelers looking for privacy, punctuality, and luxury. Each chauffeur ensures a smooth, safe, and distinguished journey, making every ride an experience of refinement."
  },
  {
    "name": "Premium Mercedes Rentals Hyderabad",
    "description": "Premium Mercedes Rentals Hyderabad offers access to a fleet of luxury Mercedes vehicles on flexible rental plans. Businesses and individuals can choose from a range of sedans and SUVs equipped with modern features for superior comfort. With maintenance, insurance, and chauffeur services included, it’s an ideal option for those who value quality and peace of mind."
  },
  {
    "name": "Mercedes Car Hire Hyderabad",
    "description": "Mercedes Car Hire Hyderabad allows clients to rent premium Mercedes vehicles for corporate or personal use, complete with skilled chauffeurs. Whether for day-long business trips, weekend events, or executive meetings, this service ensures sophistication, punctuality, and reliability in every journey."
  },
  {
    "name": "Executive Mercedes Cab Hyderabad",
    "description": "Executive Mercedes Cab Hyderabad provides professional-grade transport for senior management, corporate guests, and business travelers. Featuring plush interiors, quiet cabins, and trained chauffeurs, the service guarantees a relaxed and productive travel environment throughout Hyderabad."
  },
  {
    "name": "Corporate Mercedes Service Hyderabad",
    "description": "Corporate Mercedes Service Hyderabad is designed specifically for companies seeking reliable, high-end travel arrangements. The service supports daily executive commutes, client pick-ups, and VIP events with a fleet of Mercedes vehicles managed under flexible monthly or yearly contracts."
  },
  {
    "name": "Mercedes with Driver Hyderabad",
    "description": "Mercedes with Driver Hyderabad offers clients the convenience of renting luxury Mercedes vehicles accompanied by skilled chauffeurs. Ideal for corporate travelers, weddings, or city tours, this service ensures comfort, privacy, and professionalism every step of the way."
  },
  {
    "name": "Best Mercedes Taxi Hyderabad",
    "description": "Best Mercedes Taxi Hyderabad combines the reliability of professional cab services with the luxury of Mercedes-Benz vehicles. Known for its punctuality and impeccable service, this option is perfect for executives and high-profile clients requiring safe and elegant travel."
  },
  {
    "name": "Mercedes Benz Sedan Hire Hyderabad",
    "description": "Mercedes Benz Sedan Hire Hyderabad provides luxury sedans ideal for executive meetings, airport transfers, and personal occasions. The sedans feature premium interiors and smooth rides, supported by courteous chauffeurs trained in professional service and city navigation."
  },
  {
    "name": "Affordable Mercedes Cab Hyderabad",
    "description": "Affordable Mercedes Cab Hyderabad delivers luxury experiences at accessible rates, offering well-maintained Mercedes vehicles with professional drivers. This service is tailored for budget-conscious clients seeking an elegant ride without compromising quality or comfort."
  },
  {
    "name": "Mercedes SUV Rental Hyderabad",
    "description": "Mercedes SUV Rental Hyderabad offers premium SUVs that combine space, power, and luxury. Perfect for corporate groups, VIPs, or families, this service ensures safe and comfortable travel across Hyderabad with expert chauffeurs and flexible booking options."
  },
  {
    "name": "Mercedes Chauffeur Services Hyderabad",
    "description": "Mercedes Chauffeur Services Hyderabad deliver executive-level chauffeur-driven Mercedes vehicles for business and leisure. Drivers are professionally trained in etiquette and route management, ensuring a smooth, punctual, and comfortable experience throughout your journey."
  },
  {
    "name": "Mercedes Event Cab Hyderabad",
    "description": "Mercedes Event Cab Hyderabad specializes in providing luxury transportation for corporate events, weddings, and special occasions. The service includes a dedicated fleet of Mercedes-Benz vehicles with chauffeurs ensuring seamless coordination and timely transfers for all attendees."
  },
  {
    "name": "Online Mercedes Booking Hyderabad",
    "description": "Online Mercedes Booking Hyderabad simplifies luxury car reservations with an easy-to-use online platform. Clients can browse available models, schedule rides, and receive instant confirmations. This digital convenience ensures premium chauffeur-driven Mercedes travel is just a few clicks away."
  }
],
"tableData": [
  ["Mercedes Benz Taxi Services in Hyderabad", "Luxury Mercedes Cab Hyderabad"],
  ["Chauffeur Mercedes Hyderabad", "Premium Mercedes Rentals Hyderabad"],
  ["Mercedes Car Hire Hyderabad", "Executive Mercedes Cab Hyderabad"],
  ["Corporate Mercedes Service Hyderabad", "Mercedes with Driver Hyderabad"],
  ["Best Mercedes Taxi Hyderabad", "Mercedes Benz Sedan Hire Hyderabad"],
  ["Affordable Mercedes Cab Hyderabad", "Mercedes SUV Rental Hyderabad"],
  ["Mercedes Chauffeur Services Hyderabad", "Mercedes Event Cab Hyderabad"],
  ["Online Mercedes Booking Hyderabad", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mercedes Benz Taxi Services in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels provides premium Mercedes Benz taxi services in Hyderabad, combining luxury and comfort for your travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Mercedes Benz Vehicles",
    "WhyChoosedescription": "Choose from our fleet of well-maintained Mercedes Benz cars, perfect for business trips, airport transfers, and special occasions."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced and courteous drivers ensure punctual and safe journeys throughout Hyderabad."
  },
  {
    "WhyChooseheading": "Sanitized and Comfortable Vehicles",
    "WhyChoosedescription": "All Mercedes Benz taxis are regularly cleaned and sanitized to maintain high standards of hygiene and comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed pricing covering fuel, tolls, and driver allowances, providing a hassle-free booking experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Customize your Mercedes Benz taxi service based on hourly, daily, or long-term rental needs."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service in Hyderabad",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs anywhere in Hyderabad, offering a seamless luxury travel experience."
  }
]


























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Mercedes Benz taxi services in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides premium Mercedes Benz taxi services in Hyderabad for corporate, personal, and special occasion travel.',
  },
  {
    question: 'How can I book a Mercedes Benz taxi in Hyderabad with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Hyderabad.',
  },
  {
    question: 'What Mercedes Benz models are available for taxi services in Hyderabad?',
    answer: 'Aaryan Travels offers top-tier Mercedes Benz models including C-Class, E-Class, and S-Class for taxi services in Hyderabad.',
  },
  {
    question: 'Are drivers professionally trained for Mercedes Benz taxi services in Hyderabad?',
    answer: 'Absolutely. Our drivers are licensed, well-groomed, and trained to offer a premium and safe travel experience.',
  },
  {
    question: 'Can I use Mercedes Benz taxi services for events or airport transfers in Hyderabad?',
    answer: 'Yes, our Mercedes Benz taxi services in Hyderabad are perfect for events, VIP travel, weddings, and airport transfers.',
  },
  {
    question: 'Is the Mercedes Benz taxi service in Hyderabad available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock Mercedes Benz taxi services in Hyderabad for your convenience.',
  },
  {
    question: 'Are hygiene and safety standards followed in Mercedes Benz taxis?',
    answer: 'All vehicles are thoroughly sanitized before each ride, and strict safety and hygiene protocols are maintained.',
  },
  {
    question: 'What are the payment options for Mercedes Benz taxi services in Hyderabad?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the Mercedes Benz taxi ride in Hyderabad?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you during your ride in Hyderabad.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Reddy',
    feedback: 'Booked a Mercedes Benz taxi in Hyderabad through Aaryan Travels – luxurious ride and very professional driver. Highly impressed!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Divya Sharma',
    feedback: 'Aaryan Travels offers the best Mercedes Benz taxi services in Hyderabad. Great service, clean cars, and always on time.',
    rating: 5,
  },
];

























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const mercedesTaxiHyderabadSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mercedes Benz Taxi Services in Hyderabad",
  "description": "Aaryan Travels offers premium Mercedes Benz taxi services in Hyderabad. Hire luxury Mercedes cars with professional chauffeurs for corporate travel, events, and special occasions at affordable prices.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Hyderabad"
  },
  "serviceType": "Mercedes Benz Taxi Services",
  "keywords": "Mercedes Benz Taxi Services in Hyderabad, Luxury Mercedes Cab Hyderabad, Chauffeur Mercedes Hyderabad, Premium Mercedes Rentals Hyderabad, Mercedes Car Hire Hyderabad, Executive Mercedes Cab Hyderabad, Corporate Mercedes Service Hyderabad, Mercedes with Driver Hyderabad, Best Mercedes Taxi Hyderabad, Mercedes Benz Sedan Hire Hyderabad, Affordable Mercedes Cab Hyderabad, Mercedes SUV Rental Hyderabad, Mercedes Chauffeur Services Hyderabad, Mercedes Event Cab Hyderabad, Online Mercedes Booking Hyderabad"
};







  return (
    <div>

<Helmet>
  <title>Mercedes Benz Taxi Services in Hyderabad | Luxury Mercedes Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book Mercedes Benz taxi services in Hyderabad with Aaryan Travels. Experience luxury Mercedes rides with professional chauffeurs for corporate trips, events, and premium travel needs."
  />
  <meta
    name="keywords"
    content="Mercedes Benz Taxi Services in Hyderabad, Luxury Mercedes Cab Hyderabad, Chauffeur Mercedes Hyderabad, Premium Mercedes Rentals Hyderabad, Mercedes Car Hire Hyderabad, Executive Mercedes Cab Hyderabad, Corporate Mercedes Service Hyderabad, Mercedes with Driver Hyderabad, Best Mercedes Taxi Hyderabad, Mercedes Benz Sedan Hire Hyderabad, Affordable Mercedes Cab Hyderabad, Mercedes SUV Rental Hyderabad, Mercedes Chauffeur Services Hyderabad, Mercedes Event Cab Hyderabad, Online Mercedes Booking Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(mercedesTaxiHyderabadSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mercedesbenztaxiserviceinhyderabad;